import { Link } from "wouter";
import { ClipboardList, FileSpreadsheet } from "lucide-react";
import type { ReactNode } from "react";
import { Logo } from "@/components/layout/Logo";

function Opcion({ href, icono, titulo, linea, tiempo }: { href: string; icono: ReactNode; titulo: string; linea: string; tiempo: string }) {
  return (
    <Link href={href} className="flex items-start gap-4 rounded-lg border-2 border-borde bg-white p-6 transition-colors hover:border-primary focus-visible:border-primary">
      <span className="mt-0.5 text-primary" aria-hidden>{icono}</span>
      <span className="flex flex-col gap-1.5">
        <span className="text-lg font-semibold">{titulo}</span>
        <span className="text-tinta-suave">{linea}</span>
        <span className="text-xs text-tinta-suave">{tiempo}</span>
      </span>
    </Link>
  );
}

/**
 * Primera pantalla para quien todavía no tiene datos (sin foto ni borrador): una sola pregunta, sin menú.
 * En cuanto sube su Excel o empieza a capturar, `Inicio` ya no lo manda aquí.
 */
export function Empezar() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-2xl flex-col gap-5 px-4 py-8">
      <Logo tono="claro" />
      <div className="mt-4">
        <h1 className="text-2xl font-semibold">¿Cómo quieres empezar tu diseño patrimonial?</h1>
        <p className="mt-1 text-tinta-suave">Elige una opción. Después puedes corregir o completar lo que quieras en Mis datos.</p>
      </div>
      <Opcion
        href="/datos/excel"
        icono={<FileSpreadsheet className="h-8 w-8" />}
        titulo="Ya llené mi Excel en Wealth X y lo tengo a la mano"
        linea="Súbelo y la app toma todos tus números y los acomoda en su lugar. El archivo se lee en tu dispositivo y no se guarda."
        tiempo="1 minuto"
      />
      <Opcion
        href="/datos"
        icono={<ClipboardList className="h-8 w-8" />}
        titulo="No tengo un Excel ya llenado: quiero empezar desde cero"
        linea="Te vamos preguntando por partes, con ejemplos, lo mismo que pide el Excel. Se guarda solo y puedes pausar cuando quieras."
        tiempo="~20 minutos para lo básico"
      />
      <p className="text-sm text-tinta-suave">¿Quieres ver primero cómo se ve? <Link href="/ejemplo" className="font-medium text-primary underline">Mira el ejemplo de Henry</Link> (no guarda nada).</p>
    </main>
  );
}
